export default __webpack_public_path__ + "static/media/es6.a309520a.svg";